import { render, staticRenderFns } from "./vis-page-reset-password.vue?vue&type=template&id=4945d57e"
import script from "./vis-page-reset-password.vue?vue&type=script&lang=js"
export * from "./vis-page-reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports